import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { CtaButton } from './CtaButton';
import { OrderBumps } from './OrderBumps';
import { Reveal } from './Reveal';
import { CheckIcon, ClockIcon, LockIcon, SparkIcon } from './icons/Icons';
import { useCountdown } from '../hooks/useCountdown';
import { activateFinalCheckout } from '../utils/checkoutNavigation';
const BASE_PRICE = 10.99;
const PRODUCT_IMAGE = 'https://cdn.magicpatterns.com/uploads/7T58E3TjTYgiqrvh4HrvYf/G-smart.png';
const offerItems = [{
  name: 'Método Maestro GastroSmart',
  detail: 'Protocolo natural de 21 días para reconstruir tu mucosa.',
  value: 97,
  image: PRODUCT_IMAGE,
  alt: 'Método Maestro GastroSmart'
}, {
  name: 'Bono 1 · Lista de Compras Antifuego',
  detail: 'Ingredientes que sanan, organizados para comprar sin perder tiempo.',
  value: 37,
  image: 'https://cdn.magicpatterns.com/uploads/tr1s81KFY1BMYTQxHTs1Gw/G-B1.png',
  alt: 'Lista de Compras Antifuego mostrada en una tablet'
}, {
  name: 'Bono 2 · 20 Desayunos que Sanan',
  detail: 'Opciones rápidas para empezar el día sin activar el ardor.',
  value: 47,
  image: 'https://cdn.magicpatterns.com/uploads/kZhyy3V478wQVemAfKMp4s/G-b2.png',
  alt: 'Portada de 20 Desayunos que Sanan'
}, {
  name: 'Bono 3 · Batidos de Emergencia',
  detail: 'Tu extintor personal para los ataques agudos de ardor.',
  value: 27,
  image: 'https://cdn.magicpatterns.com/uploads/kXSDahp1h3reraYGXtsQNm/G-b3.png',
  alt: 'Portada de Batidos de Emergencia'
}];
export function OfferSection() {
  const {
    minutes,
    seconds
  } = useCountdown(14 * 60 + 59);
  const [orderTotal, setOrderTotal] = useState(BASE_PRICE);
  const pad = (number: number) => number.toString().padStart(2, '0');
  return <section id="oferta" className="w-full scroll-mt-20 bg-[#202923] py-16 text-white sm:py-24" data-id="element-255" data-mp="16sxc83dn0dk">
      <div className="mx-auto max-w-6xl px-5" data-id="element-256" data-mp="3scklj1xlg2xq">
        <Reveal data-id="element-257" data-mp="3sex49hb6ehbu">
          <div className="mx-auto max-w-3xl text-center" data-id="element-258" data-mp="3ttzs48y1keo7">
            <span className="inline-flex items-center gap-2 rounded-full bg-[#9fbd91]/15 px-4 py-1.5 text-xs font-extrabold uppercase tracking-[0.18em] text-[#b9d8aa]" data-id="element-259" data-mp="3tuj0axxw3op1">
              <SparkIcon className="h-4 w-4" strokeWidth={2.2} data-id="element-260" data-mp="3ku2wfnd8ifjn" />
              El sistema completo
            </span>
            <h2 className="mt-4 font-display text-3xl font-black leading-tight sm:text-5xl" data-id="element-261" data-mp="3otlhqk8ywsn0">
              Hoy no te llevas solo un ebook. Te llevas un sistema completo de sanación.
            </h2>
            <p className="mx-auto mt-4 max-w-2xl text-lg leading-relaxed text-white/68" data-id="element-262" data-mp="3fv04n4m9m5tm">
              Cada parte fue diseñada para ayudarte a apagar el ardor, reconstruir la mucosa y recuperar tu libertad alrededor de la comida.
            </p>
          </div>
        </Reveal>

        <div className="mx-auto mt-10 max-w-4xl overflow-hidden rounded-3xl border border-white/10 bg-white shadow-2xl" data-id="element-263" data-mp="2s4dv18wm4dhi">
          <div className="overflow-x-auto" data-id="element-264" data-mp="2x2ff9x5ryiuk">
            <table className="w-full min-w-[620px] text-left text-[#29312c]" data-id="element-265" data-mp="2dhxbj7ts5lqj">
              <thead className="bg-[#eaf0e5] text-xs font-extrabold uppercase tracking-[0.14em] text-[#506550]" data-id="element-266" data-mp="2dk1d3j47i8nn">
                <tr data-id="element-267" data-mp="28l6xsr5g728a"><th className="px-6 py-4" data-id="element-268" data-mp="28l6t4dui6e1y">Lo que incluye</th><th className="px-6 py-4 text-right" data-id="element-269" data-mp="2mjoei4wxregp">Valor real</th></tr>
              </thead>
              <tbody data-id="element-270" data-mp="2igs0ysm968jm">
                {offerItems.map((item, index) => <tr key={item.name} className={index < offerItems.length - 1 ? 'border-b border-[#698b68]/10' : ''} data-id="element-271" data-mp="2wgje6r4y3kwk" data-mpi={index}>
                    <td className="px-6 py-5" data-id="element-272" data-mp="2rihty2vs9fji">
                      <div className="flex items-center gap-4" data-id="element-273" data-mp="2rflw0ejxqqv2">
                        <img src={item.image} alt={item.alt} width="96" height="96" loading="lazy" decoding="async" className="h-16 w-16 shrink-0 rounded-xl border border-[#698b68]/10 object-cover shadow-sm sm:h-20 sm:w-20" data-id="element-274" data-mp="365b12kv5ff0m" />
                        <div className="flex min-w-0 items-start gap-3" data-id="element-275" data-mp="18gxq1in4u2bf">
                          <span className="mt-0.5 flex h-6 w-6 shrink-0 items-center justify-center rounded-full bg-[#698b68] text-white" data-id="element-276" data-mp="1dgk4fvep5olt"><CheckIcon className="h-3.5 w-3.5" strokeWidth={3} data-id="element-277" data-mp="1i9mzy931b84n" /></span>
                          <div data-id="element-278" data-mp="1m95caggsiavv"><strong className="block font-display text-base" data-id="element-279" data-mp="1m9x73p2kc4l3">{item.name}</strong><span className="mt-0.5 block text-sm text-[#647067]" data-id="element-280" data-mp="pkxwi3eiaqpq">{item.detail}</span></div>
                        </div>
                      </div>
                    </td>
                    <td className="px-6 py-5 text-right font-display text-lg font-black" data-id="element-281" data-mp="ykcleyf0yt84">${item.value}</td>
                  </tr>)}
              </tbody>
              <tfoot className="bg-[#f4f6f1]" data-id="element-282" data-mp="13hunc4umk86m">
                <tr data-id="element-283" data-mp="2a0sw6efmwlon"><td className="px-6 py-5 font-display text-lg font-black" data-id="element-284" data-mp="29yzl8mxznfau">Valor total real</td><td className="px-6 py-5 text-right font-display text-2xl font-black text-[#8d3524]" data-id="element-285" data-mp="2eykvvumitc3e">$208</td></tr>
              </tfoot>
            </table>
          </div>
        </div>

        <Reveal delay={0.12} data-id="element-286" data-mp="2k3y20q92rysw">
          <div className="mx-auto mt-10 max-w-xl rounded-3xl bg-white p-7 text-center text-[#29312c] shadow-2xl sm:p-9" data-purchase-product data-product-title="Método GastroSmart" data-product-edition="Acceso Completo + Bonos" data-product-price={String.fromCharCode(36) + orderTotal.toFixed(2)} data-product-thumbnail={PRODUCT_IMAGE} data-id="element-287" data-mp="2k3ofxdr5ibsh">
            <p className="text-xs font-extrabold uppercase tracking-[0.18em] text-[#698b68]" data-id="element-288" data-mp="21bvjtagscagj">Todo esto hoy por solo</p>
            <motion.div key={orderTotal} initial={{
            scale: 0.9,
            opacity: 0.65
          }} animate={{
            scale: 1,
            opacity: 1
          }} transition={{
            type: 'spring',
            stiffness: 210,
            damping: 13
          }} className="mt-2 font-display text-6xl font-black text-[#e0611f] sm:text-7xl" aria-live="polite" data-id="element-289" data-mp="1wgg7imyfemm8">
              ${orderTotal.toFixed(2)}
            </motion.div>
            <p className="mt-2 font-semibold text-[#5f6b62]" data-id="element-290" data-mp="1k3m93r6b14a4">Sí, leíste bien. Menos que una pizza.</p>

            <div className="mt-6" data-id="element-291" data-mp="1ove3kcskzu5j">
              <CtaButton href="#checkout-final" onClick={activateFinalCheckout} label="SÍ, QUIERO SANAR MI GASTRITIS AHORA" price={'TOTAL ' + String.fromCharCode(36) + orderTotal.toFixed(2)} data-id="element-292" data-mp="1owfdgdxv2alo" />
            </div>

            <div className="mt-4 flex flex-col items-center justify-center gap-2 text-xs text-[#5a6b5c] sm:flex-row sm:gap-4" data-id="element-293" data-mp="1f5b0fjrqwzth">
              <span className="flex items-center gap-1.5" data-id="element-294" data-mp="27tqbjv7raxzj"><LockIcon className="h-4 w-4 text-[#698b68]" strokeWidth={2} data-id="element-295" data-mp="27snndv1tj9nb" />Acceso inmediato · Pago seguro</span>
              <span className="flex items-center gap-1.5 font-bold text-[#8d3524]" data-id="element-296" data-mp="1ttfkos6g5jed"><ClockIcon className="h-4 w-4" strokeWidth={2.2} data-id="element-297" data-mp="1ys8zcnxgzgg4" />Expira en {pad(minutes)}:{pad(seconds)}</span>
            </div>
          </div>
        </Reveal>

        <OrderBumps onTotalChange={setOrderTotal} data-id="element-298" data-mp="ih50391uwtl0" />
      </div>
    </section>;
}